import { render, staticRenderFns } from "./ExternalData.vue?vue&type=template&id=19416cf0"
import script from "./ExternalData.vue?vue&type=script&lang=js"
export * from "./ExternalData.vue?vue&type=script&lang=js"
import style0 from "./ExternalData.vue?vue&type=style&index=0&id=19416cf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports